import { ProviderService } from '../../domain/entities/ProviderService'

interface RawProviderService {
  id: number
  code: string
  name: string
}

export function toProviderService(raw: RawProviderService): ProviderService {
  return {
    id: raw.id,
    code: String(raw.code),
    name: raw.name,
  }
}

export function toProviderServices(raw: RawProviderService[]): ProviderService[] {
  return raw.map(toProviderService)
}
